import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { Prompt } from 'react-router';
import { useParams } from 'react-router-dom';
import MenuGroupEditHeader from './containers/MenuGroupEditHeader/MenuGroupEditHeader';
import MenuGroupItemsList from './containers/MenuGroupItemsList/MenuGroupItemsList';
import menuGroupEditStore from './store/menuGroupEditStore';
import { SCREENS } from 'src/constants/screens';
import { localeStore } from 'src/mobx/localesStore';
import { getTranslate, scrollToErrorElement } from 'src/utils/helpers';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import { getPromptProps } from 'src/view/components/CustomPrompt/helper';
import LoadingOverlay from 'src/view/components/LoadingOverlay/LoadingOverlay';
import Headers from 'src/view/containers/Headers/Headers';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import { BUTTON_TITLE } from '~/constants/main';
import './style.scss';

const MenuGroupEditScreen = observer((): JSX.Element => {
  const { id: menuGroupId } = useParams<{ id?: string }>();

  useEffect(() => {
    if (menuGroupId) menuGroupEditStore.fetchMenuGroup(menuGroupId);
    // on quit edit
    return () => menuGroupEditStore.clearEditing();
  }, []);

  const onSave = () => {
    const { validate, createMenuGroup, updateMenuGroup } = menuGroupEditStore;

    validate();
    if (!menuGroupEditStore.validation.valid) {
      scrollToErrorElement();
      return;
    }

    if (menuGroupId) {
      updateMenuGroup(menuGroupId);
    } else {
      createMenuGroup();
    }
  };

  return (
    <>
      <Headers>
        <HeaderBack
          title={menuGroupId ? getTranslate(menuGroupEditStore.editableMenuGroup.name) : 'menu_group_name_placeholder'}
          noTranslation={!!menuGroupId}
          isLoading={menuGroupEditStore.loadingOnFetch}
          path={SCREENS.MENU_GROUPS()}
        />
      </Headers>
      <div className="d-flex flex-column flex-grow-1 mt-6">
        <MenuGroupEditHeader />
        <MenuGroupItemsList />
        <Button
          title={localeStore.t(BUTTON_TITLE.SAVE)}
          onClick={onSave}
          loading={menuGroupEditStore.loadingOnFetch || menuGroupEditStore.loadingOnSave}
          style={{ pointerEvents: menuGroupEditStore.draggingItem ? 'none' : 'auto' }}
          className="menu-group-edit__save-btn"
        />
      </div>
      <LoadingOverlay visible={menuGroupEditStore.loadingOnSave} refreshing />
      <Prompt when={menuGroupEditStore.isEdited} message={getPromptProps()} />
    </>
  );
});

export default MenuGroupEditScreen;
